import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { PAGE_SIZE } from "../../constants";
import { useGetSupportTicketsQuery } from "./supportTicketApiSlice";
import { getSupportTicketStatusLabel } from "./supportTicketUtils";
import { useBreakpoint } from "../../hooks/useBreakpoint";
import { shortDate } from "../chat_sessions/MobileChatSessionList";
import { ChipRow, ListPageShell, ListPagination, ListTable, Tag, chip, clamp2 } from "../../components/listPage";

// 접수됨 first: what is still waiting for an answer.
const STATUSES = [["전체", null], ["접수됨", "open"], ["답변됨", "replied"], ["종료", "closed"]];

/** 지원 요청 관리 — every trainee's tickets, in the shared list layout (components/listPage.js). */
const AdminSupportTicketsPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isMobile } = useBreakpoint();
  const queryParams = new URLSearchParams(location.search);
  const page = Number(queryParams.get("page") || 1);
  const page_size = Number(queryParams.get("page_size") || PAGE_SIZE);
  const status = queryParams.get("status");

  const { data, isLoading, isError } = useGetSupportTicketsQuery({ page, page_size, ...(status ? { status } : {}) });
  const tickets = data?.results || [];

  const setQuery = (changes) => {
    const p = new URLSearchParams(location.search);
    Object.entries(changes).forEach(([k, v]) => (v ? p.set(k, v) : p.delete(k)));
    if (!("page" in changes)) p.delete("page");
    navigate(`${location.pathname}?${p.toString()}`);
  };

  const statusTag = (t) => {
    const s = getSupportTicketStatusLabel(t.status);
    return <Tag tone={s.tone}>{s.text}</Tag>;
  };
  const author = (t) => t.author?.full_name || t.author?.username;

  return (
    <ListPageShell isMobile={isMobile} icon="life ring" title="지원 요청 관리" subtitle="사용자가 제출한 피드백 확인 및 답변">
      <ChipRow
        count={data?.count}
        unit="건"
        groups={[
          STATUSES.map(([label, value]) => (
            <button key={label} type="button" onClick={() => setQuery({ status: value })} style={chip((status || null) === value)}>
              {label}
            </button>
          )),
        ]}
      />
      <ListTable
        isMobile={isMobile}
        loading={isLoading}
        rows={tickets}
        empty={isError ? "요청 목록을 불러오지 못했습니다." : "제출된 피드백이 없습니다."}
        onRowClick={(t) => navigate(`/admin/support-tickets/${t.id}`)}
        columns={[
          { key: "status", label: "상태", render: statusTag },
          { key: "author", label: "작성자", nowrap: true, render: (t) => <span style={{ fontWeight: 600 }}>{author(t)}</span> },
          { key: "body", label: "내용", render: (t) => <div style={{ ...clamp2, color: "#424245" }}>{t.body}</div> },
          { key: "created", label: "제출일", muted: true, render: (t) => shortDate(t.created_at) },
        ]}
        card={{
          title: author,
          tags: (t) => [<React.Fragment key="s">{statusTag(t)}</React.Fragment>],
          meta: (t) => [shortDate(t.created_at)],
          body: (t) => t.body,
        }}
      />
      <ListPagination page={page} count={data?.count || 0} pageSize={page_size} onChange={(pg) => setQuery({ page: String(pg) })} />
    </ListPageShell>
  );
};

export default AdminSupportTicketsPage;
